import { applyStylesToMobileExperience } from 'src/molecules/Shared/2024_Q1_people_magic/BaseAnimatedExperienceController/BaseAnimatedExperienceController.styles';
import styled, { css } from 'styled-components';

export const ProfitSalesAnnouncementContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  position: relative;
  border-radius: 23px;
  overflow: hidden;
  width: 100%;

  ${applyStylesToMobileExperience(css`
    max-width: 800px;
  `)}
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 2;
  padding: 10rem 2rem;
  max-width: 1040px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7.5rem 2rem;

  ${applyStylesToMobileExperience(css`
    flex-direction: column;
    row-gap: 2.8rem;
    justify-content: center;
    align-items: center;
    padding: 4.375rem 1.5rem;
  `)}
`;

export const PeopleMagicProfitLogoContainer = styled.div`
  max-width: 635px;

  .gatsby-image-wrapper {
    margin-right: 2rem;
  }

  ${applyStylesToMobileExperience(css`
    margin: 0 auto;
    max-width: 450px;
    display: flex;
    align-items: center;
    justify-content: center;

    .gatsby-image-wrapper {
      margin-right: unset;
    }

    > svg {
      width: 80%;
    }
  `)}
`;

export const TextBlock = styled.div`
  max-width: 445px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  row-gap: 1rem;

  .link-branded {
    margin-top: 1rem;
    margin-right: auto;
    padding: 13px 40px;
  }

  ${applyStylesToMobileExperience(css`
    align-items: center;

    p,
    h1 {
      text-align: center;
    }

    .link-branded {
      margin: 2rem auto 0;
      width: 100%;
      padding: 10px 18px;
      max-width: 340px;
    }
  `)}
`;
